import { XlsxFile } from '../xlsx';
import type { StorageProvider } from './provider';
import { $popup } from '@/App';
import { XlsxViewer } from '@/components/XlsxViewer';

const input = document.createElement('input');
input.type = 'file';
document.body.appendChild(input);
input.style.display = 'none';

export const xlsxProvider: StorageProvider = {
  async loadData() {
    input.click();
    const file = await new Promise<File | null>(resolve => {
      input.onchange = () => resolve(input.files?.[0] ?? null);
    });
    if (!file) {
      return null;
    }

    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onload = async () => {
        try {
          const result = await XlsxFile.fromBuffer(
            new Uint8Array(reader.result as ArrayBuffer),
          );
          console.log(result);
          $popup.set(
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
              <XlsxViewer xlsx={result} />
            </div>,
          );
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  },
  saveData() {
    throw new Error('Not implemented');
  },
  saveAs() {
    throw new Error('Not implemented');
  },
};
